import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api";
import { rfiKeys } from "@/lib/query";

interface Rfi {
  id: string;
  projectId: string;
  number: string | null;
  subject: string | null;
  status: string | null;
  priority: string | null;
  submittedBy: string | null;
  assignedTo: string | null;
  dateSubmitted: string | null;
  dateRequired: string | null;
  dateAnswered: string | null;
  question: string | null;
  answer: string | null;
  costImpact: string | null;
  scheduleImpact: string | null;
}

export type { Rfi };

export function useRfis(projectId?: string) {
  return useQuery({
    queryKey: [...rfiKeys.all, projectId],
    queryFn: () => apiFetch<Rfi[]>(projectId ? `/rfis?projectId=${projectId}` : "/rfis"),
  });
}

export function useRfi(id: string) {
  return useQuery({
    queryKey: [...rfiKeys.all, "detail", id],
    queryFn: () => apiFetch<Rfi>(`/rfis/${id}`),
    enabled: !!id,
  });
}
